import { Navigation } from 'swiper';
export const defaultSwiperArgs = {
    spaceBetween: 0,
    slidesPerView: 'auto',
    slidesPerGroup: 3,
    modules: [Navigation],
};
export function getRestyledSwiperArgs(id = '') {
    return {
        spaceBetween: 0,
        slidesPerView: 'auto',
        slidesPerGroup: 3,
        modules: [Navigation],
        threshold: 10,
        navigation: {
            prevEl: `#sessions-wrapper-${id} .swiper-button-prev`,
            nextEl: `#sessions-wrapper-${id} .swiper-button-next`,
        },
        breakpoints: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            992: {
                direction: 'horizontal',
                spaceBetween: 0,
                slidesPerView: 'auto',
                slidesPerGroup: 3,
            },
        },
    };
}
